<div class="module-wrapper content-wrapper">
  <!-- <mat-card> -->
  <mat-card-content>
    <div class="head-container">
      <h1></h1>
      <span class="spacer"></span>
      <div>
        <div class="btn-wrapper">
          <button mat-flat-button color="" class="btn-warn" aria-label="Assign User(s)" (click)="openDialog()"> +
            {{'collectionById.collectionUsers.btnAssign' | translate}}</button>
        </div>
      </div>
    </div>
    <div class="input-container">
      <div class="input-fields-wrapper">
        <div class="row input-wrapper">
          <!-- <div class="row"> -->
          <div class="col-md-4">
            <input type="text" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model=""
              [(ngModel)]='clientFirstName' placeholder="{{'collectionById.collectionUsers.inputFname' | translate}}"
              filterValidator="Name">
          </div>
          <div class="col-md-4">
            <input type="text" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model=""
              [(ngModel)]='clientLastName' placeholder="{{'collectionById.collectionUsers.inputLname' | translate}}"
              filterValidator="Name">
          </div>
          <div class="col-md-4">
            <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="userRoles" [(ngModel)]="selectedRole"
              placeholder="{{'collectionById.collectionUsers.inputSelect' | translate}}">
            </ng-multiselect-dropdown>
          </div>
          <!-- </div> -->
        </div>

        <div class="btn-wrapper">
          <button mat-flat-button color="" class="btn-primary" aria-label="Search"
            (click)='itemFilter()'>{{'collectionById.collectionUsers.btnSearch' | translate}}</button>
          <button mat-flat-button color="" class="btn-flat" aria-label="Reset"
            (click)='resetFilter()'>{{'collectionById.collectionUsers.btnReset' | translate}}</button>
        </div>
      </div>
    </div>
    <div class="gap">
      <div class="data-not-found-container" *ngIf='noDataFound'>
        <p>{{'collectionById.collectionUsers.errMsg1' | translate}}</p>
      </div>
      <div *ngIf="isNoUsers" class="row data-not-found-container table-container">
        <span>{{'collectionById.collectionUsers.errMsg2' | translate}}</span>
      </div>
      <div *ngIf="!isNoUsers && !noDataFound">
        <div class="table-container">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.collectionUsers.column1' |
                translate}}</th>
              <td mat-cell *matCellDef="let row">
                <span class="">{{row?.firstName | titlecase}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.collectionUsers.column2' |
                translate}}</th>
              <td mat-cell *matCellDef="let row">
                {{row?.lastName}}
              </td>
            </ng-container>

            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.collectionUsers.column3' |
                translate}}</th>
              <td mat-cell *matCellDef="let row">
                {{row?.phone}}
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.collectionUsers.column4' |
                translate}}</th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="row.emailId.length > 30 then sliceEmail else noSliceEmail"></ng-container>
                <ng-template #sliceEmail>
              <td matTooltip="{{row?.emailId}}" matTooltipPosition="above" innerHtml="{{row?.emailId | slice:0:15}}">
                ...
              </td>
              </ng-template>
              <ng-template #noSliceEmail>
                <td>{{row.emailId}}</td>
              </ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="role">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="role-col">
                {{'collectionById.collectionUsers.column5' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="demo" *ngIf="row.useraccessLevels != ''">
                  {{row.useraccessLevels}}
                </div>
                <div class="demo" *ngIf="row.useraccessLevels == ''">
                  {{row.userAccessLevel.replace('Client-Admin','Admin')}}<span class="roleSpan"> </span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.collectionUsers.column6' |
                translate}}</th>
              <td mat-cell *matCellDef="let row">
                <i *ngIf="row?.active === true" class="fa fas fa-circle publish"
                  matTooltip="{{'collectionById.collectionUsers.statusTooltip.active' | translate}}"
                  matTooltipPosition="above">
                </i>
                <span *ngIf="row?.active === false" class="glyphicon glyphicon-adjust unpublish"
                  matTooltip="{{'collectionById.collectionUsers.statusTooltip.inactive' | translate}}"
                  matTooltipPosition="above">
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="modifiedDate">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collectionById.collectionUsers.column7' |
                translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="text-bold"> {{row?.modifiedUserName}} </div>
                <div> {{row?.modifiedDateTime | dateAgo}} </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" style="width: 6% !important;">
                {{'collectionById.collectionUsers.column8' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button (click)="deleteUser(row)"
                [ngClass]="{'disableIcon': roleSer.accessData && roleSer.accessData.deleteAllowed && row.useraccessLevels
                  && row.useraccessLevels==='Account Admin' && row.totalAccountAdminCount === 1 || row.useruuid === currentUserData.useruuid}"
                  matTooltip="{{'collectionById.collectionUsers.actionDel' | translate}}">
                  <mat-icon>delete_outline</mat-icon>
                </button>

                <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="deleteUser(row)" [disabled]="roleSer.accessData && roleSer.accessData.deleteAllowed
                    && row.useraccessLevels && row.useraccessLevels==='Account Admin'">

                   //----Old code-------
                    <button mat-menu-item (click)="deleteUser(row)" [disabled]="roleSer.accessData && roleSer.accessData.deleteAllowed
                  && row.useraccessLevels && row.useraccessLevels.includes('Account Admin')">

                    <mat-icon>delete_outline</mat-icon>
                    <span>{{'collectionById.collectionUsers.actionDel' | translate}}</span>
                  </button>
                </mat-menu> -->
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <div class="collection-paginator" [ngClass]="{'hidden': showPaginator === false}">
          <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </div>

  </mat-card-content>
</div>
